module.exports = __webpack_public_path__ + "img/av064.e3c2b27b.png";